import { createStyles } from '@mantine/core';

const useProgramAgendaStyles = createStyles(theme => ({
  agendaContent: {
    padding: `${theme.spacing.xl} calc(${theme.spacing.xl} * 2) calc(${theme.spacing.xl} * 2)`,
    gap: 0,
  },
  grid: {
    width: '50%',
    display: 'grid',
    gridTemplateColumns: '4fr 1fr',
  },
  header: {
    paddingBottom: theme.fontSizes.xs,
    textAlign: 'left',
    gap: 0,
  },
  agendaItem: {
    height: `calc(${theme.spacing.lg} * 2)`,
    cursor: 'pointer',
  },
  shadow: {
    boxShadow: `calc(${theme.fontSizes.xs} / 2) calc(${theme.fontSizes.xs} / 5) calc(${theme.fontSizes.xs} / 2) calc(${theme.fontSizes.xs} / 5) rgba(0, 0, 0, 0.1)`,
    border: 0,
  },
  firstColumn: {
    paddingLeft: theme.spacing.sm,
    borderRadius: `calc(${theme.fontSizes.xs} / 2) 0px 0px calc(${theme.fontSizes.xs} / 2) !important`,
  },
  lastColumn: {
    justifyContent: 'center',
    background: 'white',
    borderRadius: `0px calc(${theme.fontSizes.xs} / 2) calc(${theme.fontSizes.xs} / 2) 0px !important`,
  },
  calendar: {
    fontFamily: `${theme.fontFamily} !important`,
    borderRadius: theme.radius.md,
  },
}));

export default useProgramAgendaStyles;
